<template>
	<div class="navbar">
		<!-- <div class="head-logo">系统LOGO</div> -->
		<div class="head-bars" :style="{ marginLeft: isCollapse?'3.36rem':'10rem'}">
			<span class="bars" @click="handleLefeMenu">
				<i :class="isCollapse?'el-icon-s-unfold':'el-icon-s-fold'"></i>
			</span>
		</div>
		<ul class="head-right">
			<li class="head-item">
				<i class="el-icon-user" style="margin-right: 0.24rem;;"></i>
<!--				当前时间：{{new Date().format("yyyy年MM月dd日 dddd")}}-->
        你好，{{userInfo.nickname}}
			</li>
			<li class="head-item">
				<el-dropdown @command="handleCommand">
					<div type="primary">
						<img class="user-tx" :src="userInfo.avatar">
						<!-- <span class="user-name">{{userInfo.name}}</span> -->
						<!-- <i class="el-icon-arrow-down el-icon--right"></i> -->
					</div>
					<el-dropdown-menu slot="dropdown">
						<!-- <el-dropdown-item command="userCenter">
							<i class="el-icon-user"></i>个人信息
						</el-dropdown-item> -->
						<el-dropdown-item command="updatePwd">
							<i class="iconfont icon-xiugaimima"></i>修改密码
						</el-dropdown-item>
						<el-dropdown-item command="updateAvatar">
							<i class="iconfont icon-txxg"></i>修改头像
						</el-dropdown-item>
						<el-dropdown-item command="logout">
							<i class="el-icon-switch-button"></i>退出登录
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</li>
			<li style="line-height: initial;">
				<!-- 修改密码 -->
				<modify-pwd ref="modifyPwd"></modify-pwd>
				<!-- 修改密码 -->
				<avatar ref="avatar"></avatar>
			</li>
		</ul>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex'
	import modifyPwd from "@/components/modifyPwd.vue"
	import avatar from "@/components/avatar.vue"
	export default {
		name: "Navbar",
		components: {
			modifyPwd,
			avatar
		},
		computed: {
			...mapGetters(['isCollapse', 'userInfo']),
		},
		methods: {
			handleCommand(command) {
				if (command == "logout") { //退出登录
					localStorage.removeItem("user-account");
					this.$store.dispatch("user/logout").then(() => {
						window.location.reload()
					})
				} else if (command == "userCenter") { //个人中心
					this.$router.push({
						name: "personal"
					});
				} else if (command == "updatePwd") { //修改密码
					let userId = this.$store.getters.userInfo.userId;
					this.$refs.modifyPwd.show({
						userId: userId
					});
				} else if (command == "updateAvatar") { // 修改头像
					this.$refs.avatar.show();
				}
			},
			handleLefeMenu() {
				this.$store.dispatch('menu/setLeftCollapse', !this.isCollapse);
			},
		}
	}
</script>

<style lang="scss" scoped>
	.navbar {
		background-color: #252629;

		.head-logo {
			padding: 0 0.4rem;
			font-size: 0.96rem;
			font-weight: bold;
		}

		.head-bars {
			flex: 1;
			transition: margin-left 300ms ease-in-out;

			i {
				font-size: 1.4rem;
				color: #22C1D3;
				position: relative;
				top: 0.28rem;
				cursor: pointer;
			}
		}

		.head-right {
			display: flex;

			.head-item {
				padding: 0 0.6rem;
				font-size: 0.6rem;
				color: #22C1D3;
				cursor: pointer;
			}

			.user-tx {
				width: 1.8rem;
				height: 1.8rem;
				border-radius: 0.24rem;
				margin-right: 0.2rem;
				vertical-align: middle;
				background-color: #5FA1A1;
				border: 1px solid #67FFFB;
			}
		}
	}
</style>